import PostList from '@/data/post/view/PostList.vue'
import PostEditor from '@/data/post/view/PostEditor.vue'

const list = {
  path: '/post',
  name: 'post-list',
  component: PostList
}
const creator = {
  path: '/post/creator',
  name: 'createPost',
  component: PostEditor
}
const editor = {
  path: '/post/editor/:id(\\d+)',
  name: 'updatePost',
  component: PostEditor
}

export default [list, creator, editor]
